export function getDomain() {
  const { hostname } = window.location;
  const parts = hostname.split('.').reverse();

  if (parts.length < 2) {
    return hostname;
  }

  return `.${parts[1]}.${parts[0]}`;
}



// WEBPACK FOOTER //
// ./src/utils/domain.js